var map = {
	"./core/components/actionButtons/actionButtons.component.js": 764,
	"./core/components/breadcrumbs/breadcrumbs.component.js": 765,
	"./core/components/contacts/contactPerson.component.js": 766,
	"./core/components/export/exportButton.component.js": 767,
	"./core/components/manageBlock/manageBlock.component.js": 768,
	"./core/components/manageBlock/manageBlockCheckboxTable.component.js": 769,
	"./core/components/manageBlock/manageBlockFilters.component.js": 770,
	"./core/components/manageBlock/manageBlockViewOnly.component.js": 771,
	"./core/components/modificationHistory/modificationHistory.component.js": 772,
	"./core/components/stepsPicker/stepsPicker.component.js": 773,
	"./sections/widgets/editor/common/widgetEditorBackgroundSettings.component.js": 774,
	"./sections/widgets/editor/common/widgetEditorButton.component.js": 775,
	"./sections/widgets/editor/common/widgetEditorButtonSettings.component.js": 776,
	"./sections/widgets/editor/common/widgetEditorCopyPaste.component.js": 777,
	"./sections/widgets/editor/common/widgetEditorFontSettings.component.js": 778,
	"./sections/widgets/editor/common/widgetEditorLanguagePicker.component.js": 779,
	"./sections/widgets/editor/common/widgetEditorMenu.component.js": 780,
	"./sections/widgets/editor/common/widgetEditorMenuItem.component.js": 781,
	"./sections/widgets/editor/common/widgetEditorProgressBar.component.js": 782,
	"./sections/widgets/editor/common/widgetEditorProgressBarSettings.component.js": 783,
	"./sections/widgets/editor/common/widgetEditorTermsSettings.component.js": 784,
	"./sections/widgets/editor/customWidget/customWidgetEditor.component.js": 785,
	"./sections/widgets/editor/pollWidget/pollWidgetEditor.component.js": 786,
	"./sections/widgets/editor/pollWidget/widgetAnswerEditor.component.js": 787,
	"./sections/widgets/editor/pollWidget/widgetEditorAnswer.component.js": 788,
	"./sections/widgets/editor/pollWidget/widgetEditorImageSettings.component.js": 789,
	"./sections/widgets/editor/pollWidget/widgetEditorPollBackgroundSettings.component.js": 790,
	"./sections/widgets/editor/pollWidget/widgetQuestionEditor.component.js": 791,
	"./sections/widgets/editor/sliderWidget/sliderWidgetEditor.component.js": 792,
	"./sections/widgets/editor/sliderWidget/widgetEditorSliderControls.component.js": 793,
	"./sections/widgets/editor/sliderWidget/widgetEditorSliderControlsSettings.component.js": 794,
	"./sections/widgets/editor/staticWidget/staticWidgetEditor.component.js": 795,
	"./sections/widgets/editor/videoWidget/videoWidgetEditor.component.js": 796
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 763;